import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito saber mucho de computadoras?',
    a: 'No, está diseñado para ser sencillo y puedes hacerlo todo desde tu teléfono o incluso a mano siguiendo nuestras guías.'
  }, {
    q: '¿Cuánto tiempo me tomará?',
    a: 'Puedes empezar con una sola receta hoy mismo en menos de 15 minutos.'
  }, {
    q: '¿Es un libro de cocina con recetas tuyas?',
    a: 'No, es un sistema para que tú crees el libro con TUS recetas, las que tu familia ama.'
  }, {
    q: '¿Qué pasa si mis recetas son muy simples?',
    a: 'Las recetas más simples suelen ser las que más extrañamos. Tu arroz blanco tiene un secreto que nadie más tiene.'
  }, {
    q: '¿Puedo imprimirlo después?',
    a: '¡Claro! El formato está optimizado para que puedas imprimirlo y encuadernarlo si así lo deseas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-heritage-beige" data-id="element-1">
      <div className="max-w-3xl mx-auto px-6" data-id="element-2">
        <FadeIn data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-4">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-5">
          {faqs.map((faq, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-6">
              <div className="bg-white rounded-lg shadow-sm border border-heritage-gold/20 overflow-hidden" data-id="element-7">
                <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full text-left px-6 py-5 flex justify-between items-center focus:outline-none" data-id="element-8">
                  <span className="font-serif font-semibold text-lg text-heritage-coffee pr-4" data-id="element-9">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-heritage-terracotta transition-transform duration-300 flex-shrink-0 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-10" />
                </button>
                <AnimatePresence data-id="element-11">
                  {openIndex === idx && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-12">
                      <div className="px-6 pb-5 text-heritage-coffee/80 text-lg" data-id="element-13">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}